<script lang="ts">
	import ResponsiveMenuBar from '../ResponsiveMenuBar.svelte'
	import TargetPriceMenuItem from './menuitems/TargetPriceMenuItem.svelte'
	import DashboardMenuItem from './menuitems/DashboardMenuItem.svelte'
	import LotMenuItem from './menuitems/LotMenuItem.svelte'
	import ProjectsMenuItem from './menuitems/ProjectsMenuItem.svelte'
	import RegistryMenuItem from './menuitems/RegistryMenuItem.svelte'
	import MenuItem from '../MenuItem.svelte'
	import ProfileMenuItem from './menuitems/ProfileMenuItem.svelte'
	import AdminMenuItem from './menuitems/AdminMenuItem.svelte'
	import NotificationsMenuItem from './menuitems/NotificationsMenuItem.svelte'
	import Permission from '../Permission.svelte'
	import MenuChip from '../MenuChip.svelte'
	import { UserPermission } from '$types/enums'
	import { t } from '$i18n/i18n'
	import { manualOpenWhitelist } from '$lib/stores'
	import IconMail from '$svg/icon-mail.svg?component'
	import { jwt } from '$lib/utils/jwt'
</script>

<ResponsiveMenuBar>
	<svelte:fragment slot="menu-start">
		<Permission requiredPermissions={UserPermission.FLAG_LOGGED_IN}>
			<!-- Karte -->
			<MenuItem title={$t('Map')} url="/map" permissions={UserPermission.MAP} />
			<MenuItem
				title={$t('Map')}
				url="/maplibre"
				permissions={UserPermission.MAP_V2}
				isBeta
			/>
			<!-- Projekte -->
			<ProjectsMenuItem />
			<!-- Positionen -->
			<LotMenuItem />
			<!-- Dashboard (inkl. AI-Dashboard Sub-Eintrag) -->
			<DashboardMenuItem />
			<!-- Richtpreis -->
			<TargetPriceMenuItem />
			<!-- Einbauweisen -->
			<MenuItem
				title={$t('InstallationCases.title')}
				url="/installationCases"
				permissions={UserPermission.FLAG_EBV_EVALUATION}
			/>
			<!-- Analyse Check -->
			<MenuItem
				title={$t('AnalysisCheck.menu.title')}
				url="/analysis"
				permissions={UserPermission.ANALYSIS_CHECK}
			/>
			<!-- Verwalten -->
			<RegistryMenuItem />
		</Permission>
		<MenuItem
			title={$t('Button.faq')}
			url="https://mineral-minds.de/so-funktionierts-netzwerk/"
			openInNewTab
		/>
		<!-- Temporarily disabled -->
<!--		<MenuItem-->
<!--			title="MMLV"-->
<!--			url="/mmlv"-->
<!--			permissions={UserPermission.FLAG_SYSTEM_TENANT_MEMBER}-->
<!--			openInNewTab-->
<!--			isBeta-->
<!--		/>-->
	</svelte:fragment>
	<svelte:fragment slot="menu-end" let:hamburgerActive>
		<Permission requiredPermissions={UserPermission.FLAG_LOGGED_IN}>
			{#if $jwt && $jwt.showwhitelistchip}
				<MenuChip
					label={$t('Whitelist.openConfig.btn')}
					icon={IconMail}
					onclick={() => ($manualOpenWhitelist = true)}
				/>
			{/if}
			<AdminMenuItem {hamburgerActive} />
			<NotificationsMenuItem {hamburgerActive} context="menubar" />
			<ProfileMenuItem {hamburgerActive} />
		</Permission>
	</svelte:fragment>
</ResponsiveMenuBar>
